module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_mobile_de-9e5f44c4765256a345af73c618286cdb.png";